// @ts-nocheck
import * as React from 'react';

export type DropdownItem = {
  icon?: string;
  id?: string;
  label?: string;
  link?: string;
  text?: string;
  value?: string;
};
export type JsonApiFormat = {
  data: {
    type: string;
    id?: string;
    attributes: Record<string, any>;
  };
};
export type Payload = Record<string, any>;
export type SetCurrentPagePayload = {
  page: number;
  tab: string;
};
export type NormalizedJsonApi = {
  entities: Record<string, any>;
  result: any;
  link?: string;
  data?: Record<string, any>;
};
export type StyleWrapperProps = {
  children?: React.ReactNode;
};
export type ActiveViewPayloadType = {
  id: number;
  name: string;
};
export type PageType = {
  selected: number;
};
export type PromptModalOption = {
  label: string;
  value: string;
  color: string;
  onClick: (...args: Array<any>) => any;
};
export type SetModalPayload = {
  title: string;
  subtitle: string;
  options: PromptModalOption[];
};
export type NavigationTab = {
  displayName: string;
  location: string;
};
export type RouterPayloadType = {
  search: string;
  pathname: string;
};
export type RouteType = {
  path: string;
  component: Record<string, any>;
};
export type RoutesProps = {
  isLoggedIn: boolean;
  pathname: string;
};
export type Axios = {
  get: (...args: Array<any>) => any;
  post: (...args: Array<any>) => any;
  delete: (...args: Array<any>) => any;
  patch: (...args: Array<any>) => any;
  delete: (...args: Array<any>) => any;
};
export type StaticProps = {
  children?: React.ReactNode;
};
export type Alert = {
  message: string;
  type: string;
  timeout: number;
};
export type FormAlert = {
  icon?: string;
  children: React.ReactNode;
  type: string;
};
export type PageAlert = {
  alert: Alert;
  onCloseAlert: () => void;
};
export type SystemParameters = {
  id: number;
  name: string;
  value: string;
};
export type SystemParametersListObject = Record<string, SystemParameters>;
export const SystemParametersIdEnum = Object.freeze({
  autoSaveTimeFrame: 1,
});
export type GlobalSearchPayload = {
  term: string;
  page: number;
  elementsPerPage: number;
  contentType?: string;
};
export type SchedulerObject = {
  body: string;
  taxonomyType: string;
  title: string;
  calendarUrl: string;
  timekitProjectId?: string;
};
